module.exports = __webpack_public_path__ + "static/img/why-6.24bccb16.jpg";